/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ElementRef, Inject, Injectable, ViewContainerRef } from '@angular/core'
import { resolveApplicable } from '@spartacus/core'
import {
  LAUNCH_CALLER,
  LaunchDialogService,
  LaunchOptions,
  LaunchRenderStrategy,
  LayoutConfig
} from '@spartacus/storefront'
import { BehaviorSubject, Observable, combineLatest } from 'rxjs'
import { filter, map, tap } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class CustomLaunchDialogService {
  // private _dialogClose;

  private _dialogClose = new BehaviorSubject<any | undefined>(undefined)
  private _dataSubject = new BehaviorSubject<any>(undefined)

  constructor(
    @Inject(LaunchRenderStrategy)
    protected renderStrategies: LaunchRenderStrategy[],
    protected layoutConfig: LayoutConfig,
    protected LaunchDialogService: LaunchDialogService
  ) {
    // super(renderStrategies, layoutConfig);
    // this.renderStrategies = this.renderStrategies || [];
  }

  /**
   * Open the dialog
   *
   * @param caller LAUNCH_CALLER
   * @param openElement button's Element ref
   * @param vcr View Container Ref of the container for inline rendering
   * @param data optional data which could be passed to dialog
   */
  openDialog(
    caller: LAUNCH_CALLER | string,
    openElement?: ElementRef,
    vcr?: ViewContainerRef,
    data?: any
  ): Observable<any> | undefined {
    const component = this.LaunchDialogService.launch(caller, vcr, data)

    if (component) {
      return combineLatest([component, this.dialogClose]).pipe(
        filter(([, close]) => close !== undefined),
        tap(([comp]) => {
          openElement?.nativeElement.focus()
          this.clear(caller)
          comp?.destroy()
        }),
        map(([comp]) => comp)
      )
    }
  }
  /**
 

  

  /**
   * Util method to remove element from rendered elements list
   *
   * @param caller LAUNCH_CALLER
   */
  clear(caller: LAUNCH_CALLER | string): void {
    const config = this.findConfiguration(caller)

    if (config) {
      const renderer = this.getStrategy(config)

      // Render if the strategy exists
      if (renderer) {
        renderer.remove(caller, config)
      }
    }
  }

  get dialogClose(): Observable<any | undefined> {
    return this._dialogClose.asObservable()
  }

  closeDialog(reason: any) {
    // this._dialogClose.next(reason);
    this.LaunchDialogService.closeDialog(reason)
  }

  /**
   * Returns the configuration for the caller
   *
   * @param caller LAUNCH_CALLER
   */
  protected findConfiguration(caller: LAUNCH_CALLER | string): LaunchOptions | undefined {
    if (this.layoutConfig?.launch) {
      return this.layoutConfig.launch[caller]
    }
    return undefined
  }

  /**
   * Returns the render strategy based on the configuration
   *
   * @param config Configuration for launch
   */
  protected getStrategy(config: LaunchOptions): LaunchRenderStrategy | undefined {
    return resolveApplicable(this.renderStrategies, [config])
  }
}
